// import Item from 'antd/es/list/Item';
// import React, { useEffect, useMemo, useState, useContext, useRef } from 'react';
// import { AiOutlineSearch } from 'react-icons/ai';
// import { useCallback } from 'react';
// import axios from 'axios';
// import { useNavigate } from 'react-router-dom';
// import ItemSelectBox from './ItemSelectBox';
// import { AppContext } from '../context/context';
// import DatePicker from "react-datepicker";
// import Swal from 'sweetalert2';

// const DuePaymentForm = (props) => {
//   const {
//     dueAmount,
//     loadingCallback,
//     setSeller,
//     setWarningMessage,
//     setShowModal,
//     isOpen,
//     formId,
//     paymentList,
//     paymentAccountList,
//     filteredAccountList,
//     setFilteredAccountList,
//     setSelectedAccountList,
//     setPaidAmount,
//     paymentData,
//     formData,
//     setFormData,
//     selectType,
//     setData,
//     filteredSeller,
//     setFilteredSeller,
//     customerDueInvoiceList,
//     vendorDueInvoiceList,
//     exporterDueInvoiceList,
//     carrierDueInvoiceList,
//     wholesellerDueInvoiceList
//   } = props;

//   const [uniqueMap, setUniqueMap] = useState([]);
//   const [invoiceSelect, setInvoiceSelect] = useState(false);
//   const [transactionDate, setTransactionDate] = useState(new Date);
//   const [paymentAccountAmount, setPaymentAccountAmount] = useState([{
//     methodName: '',
//     AccountName: "",
//     account_number: "",
//     payment_type_id: '',
//     payment_type_category_id: "",
//     Amount: '',
//   }]);
//   const [formError, setFormError] = useState(false);
//   const { setSaleInvoiceIdForDue, setPurchaseInvoiceIdForDue, setExporterInvoiceIdForDue, setCarrierInvoiceIdForDue, setWholesellerInvoiceIdForDue, setDuePaymentCustomDate } = useContext(AppContext);

//   const handleSubmit = (e) =>{
//     e.preventDefault();

//     // if(selectType === "exporter"){
//     //   Swal.fire("pay due option coming soon!")
//     //   return;
//     // }
//     const uniqueNamesMap = new Set();

//     const uniqueMap = paymentAccountAmount.reduce((acc, t) => {
//       const key = `${t.payment_type_category_id}_${t.payment_type_id}`;

//       if (!uniqueNamesMap.has(key) && Number(t.Amount)>=0 ) {
//         uniqueNamesMap.add(key);

//         const total = paymentAccountAmount.reduce((innerAcc, item) => {
//           if (
//             t.payment_type_category_id === item.payment_type_category_id &&
//             t.payment_type_id === item.payment_type_id && Number(item.Amount)>0
//           ) {
//             return innerAcc + (Number(item.Amount));
//           } else {
//             return innerAcc;
//           }
//         }, 0);

//         console.log("total Amount:", total);
//         acc.push({ ...t, Amount: total });
//       }

//       return acc;
//     }, []);

//     console.log("patmentList", uniqueMap);

//     const totalAmount = uniqueMap.reduce((acc, item) => {
//       return acc + Number(item.Amount);
//     }, 0);
//     console.log(totalAmount);
//     setPaidAmount(totalAmount);

//     setSelectedAccountList(uniqueMap)
//     //setShowModal(!isOpen)
//   }

//   const navigate = useNavigate();
//   const [AccountList, setAccountList] = useState([]);

//   const amountData = {
//     methodName: "cash",
//     AccountName: "",
//     account_number: "",
//     payment_type_id: "",
//     payment_type_category_id: "",
//     Amount: '',
//   }

//   // const [filteredAccountList, setFilteredAccountList] = useState([])
//   const [filteredAccountDetails, setFilteredAccountDetails] = useState({})
//   const [methodIndex, setMethodIndex] = useState(null)
//   const handleChangeInvoice = (option) => {
//     const {value, label} = option;
//     console.log("Inside SALE_invoice_id")
//     if(option?.sale_invoice_id != ""){
//       setSaleInvoiceIdForDue(value);
//     }

//     if(option?.purchase_invoice_id != ""){
//       setPurchaseInvoiceIdForDue(value);
//     }
//     if(option?.exporter_invoice_id != ""){
//       setExporterInvoiceIdForDue(value);
//     }
//     if(option?.carrier_invoice_id != ""){
//       console.log('Inside CArrier DUe ' + value);
//       setCarrierInvoiceIdForDue(value);
//     }

//     if(option?.wholesale_invoice_id != ""){
//       setWholesellerInvoiceIdForDue(value);
//     }

//     setFormError(false);
//     setInvoiceSelect(true);

//   }
//   // const handleChangeSelect = (name, option) => {
//   //   const { value, label } = option;
//   //     // setFormData({
//   //     //   ...formData,
//   //     //   [name]: value,
//   //     // });
//   //     console.log("Option", name, option);
//   //     console.log("PaymentList", paymentAccountList, paymentList);
//   //     if (name === 'payment_id') {
//   //       if (label != 'Select Payment' && value) {
//   //         setFormData((prevFormData) => ({
//   //           ...prevFormData,
//   //           method_id: '',
//   //           account_number: "",
//   //         }));
//   //         const selectedMethodObject = paymentList.find(
//   //           (method) => method.id === value
//   //         );
//   //         if (selectedMethodObject) {
//   //           setFilteredAccountList(selectedMethodObject.payment_type_category || []);
//   //         } else {
//   //           setFilteredAccountList([]);
//   //         }
//   //         const newArray = [...paymentData];
//   //         newArray[methodIndex] = selectedMethodObject;
//   //         setData(newArray);

//   //         const newArray2 = [...paymentAccountAmount];
//   //         newArray2[methodIndex] = {...amountData,
//   //           payment_type_id: value,
//   //           methodName: label,

//   //         }
//   //         setPaymentAccountAmount(newArray2);
//   //       }
//   //       if (label == 'Select Payment') {
//   //         setFormData((prevFormData) => ({
//   //           ...prevFormData,
//   //           account_id: '',
//   //           account_number: "",
//   //         }));
//   //       }
//   //     }
//   //     else if(name=='account_id'){
//   //       if (label == 'Select Account') {
//   //         setFormData((prevFormData) => ({
//   //           ...prevFormData,
//   //           account_id: '',
//   //           account_number: "",
//   //         }));
//   //         const newArray = [...paymentAccountAmount];
//   //         newArray[methodIndex] = {...amountData,
//   //           account_number: "",
//   //           AccountName: "",
//   //           payment_type_category_id: ''
//   //         }
//   //         setPaymentAccountAmount(newArray);
//   //         setFilteredAccountDetails({})
//   //       }
//   //       else{
//   //         const selectedAccount = paymentAccountList.find(
//   //           (method) => method.id === value
//   //         );

//   //         console.log("account",selectedAccount, methodIndex);
//   //         if(selectedAccount){
//   //           const newArray = [...paymentAccountAmount];
//   //           newArray[methodIndex] = {...newArray[methodIndex],
//   //             AccountName: label,
//   //             account_number: selectedAccount?.account_number,
//   //             payment_type_category_id: value
//   //           }
//   //           setPaymentAccountAmount(newArray);
//   //           setFilteredAccountDetails(selectedAccount)
//   //         }
//   //       }
//   //     }
//   //  }

//   //  useEffect(()=>{
//   //   const selectedAccount = paymentList.find(
//   //     (method) => method.type_name === "cash"
//   //   );
//   //   setFormData({...formData, payment_id: selectedAccount.id})
//   //  },[])

//   const handleChangeSelect = (name, option) => {
//   const { value, label } = option;

//   console.log("Option", name, option);
//   console.log("PaymentList", paymentAccountList, paymentList);

//   if (name === 'payment_id') {
//     if (label !== 'Select Payment' && value) {
//       setFormData((prevFormData) => ({
//         ...prevFormData,
//         method_id: '',
//         account_number: '',
//       }));

//       const selectedMethodObject = paymentList.find(
//         (method) => method.id === value
//       );

//       if (selectedMethodObject) {
//         setFilteredAccountList(selectedMethodObject.payment_type_category || []);
//       } else {
//         setFilteredAccountList([]);
//       }

//       const newArray = [...paymentData];
//       newArray[methodIndex] = selectedMethodObject;
//       setData(newArray);

//       const newArray2 = [...paymentAccountAmount];
//       newArray2[methodIndex] = {
//         ...newArray2[methodIndex], // ✅ Preserve existing data
//         payment_type_id: value,
//         methodName: label,
//       };
//       setPaymentAccountAmount(newArray2);
//     }

//     if (label === 'Select Payment') {
//       setFormData((prevFormData) => ({
//         ...prevFormData,
//         account_id: '',
//         account_number: '',
//       }));
//     }
//   }

//   else if (name === 'account_id') {
//     if (label === 'Select Account') {
//       setFormData((prevFormData) => ({
//         ...prevFormData,
//         account_id: '',
//         account_number: '',
//       }));

//       const newArray = [...paymentAccountAmount];
//       newArray[methodIndex] = {
//         ...newArray[methodIndex], // ✅ Preserve previously saved values
//         account_number: '',
//         AccountName: '',
//         payment_type_category_id: ''
//       };
//       setPaymentAccountAmount(newArray);
//       setFilteredAccountDetails({});
//     }

//     else {
//       const selectedAccount = paymentAccountList.find(
//         (method) => method.id === value
//       );

//       console.log("account", selectedAccount, methodIndex);
//       if (selectedAccount) {
//         const newArray = [...paymentAccountAmount];
//         newArray[methodIndex] = {
//           ...newArray[methodIndex], // ✅ Keep other values intact
//           AccountName: label,
//           account_number: selectedAccount?.account_number,
//           payment_type_category_id: value
//         };
//         setPaymentAccountAmount(newArray);
//         setFilteredAccountDetails(selectedAccount);
//       }
//     }
//   }
// };


//   const handleAddMethod = async () =>{
//     if(paymentData.length<paymentList.length){
//       const selectedAccount = paymentList.find(
//         (method) => method.type_name.toLowerCase() === "cash"
//       );
//       setData([...paymentData, selectedAccount])
//       const newArray = [...paymentAccountAmount];
//       let data = {...amountData,
//         methodName: selectedAccount.type_name,
//         payment_type_id: selectedAccount.id
//       }
//       setPaymentAccountAmount([...paymentAccountAmount, data])
//     }
//   }

//   const handleCancelMethod = (id, par) => {
//     if(paymentData.length>1){
//       const indexToRemove = paymentData.findIndex((item, index) => index === par);
//       if (indexToRemove !== -1) {
//         const newData = [...paymentData];
//         newData.splice(indexToRemove, 1);
//         setData(newData);
//       }
//       const indexToRemove2 = paymentAccountAmount.findIndex((item, index) => index === par);
//       if (indexToRemove2 !== -1) {
//         const newData2 = [...paymentAccountAmount];
//         newData2.splice(indexToRemove2, 1);
//         setPaymentAccountAmount(newData2);
//       }
//     }
//   };

//   const datePickerRef2 = useRef(null);

//   const handleDivClick2 = () => {
//     if (datePickerRef2.current) {
//       datePickerRef2.current.setOpen(true); // Programmatically open the date picker
//     }
//   };

//   return (
//     <div className="duration-500">
//       <div class="flex flex-row justify-between items-center py-3 px-1">
//         <h1 class="text-md font-semibold font-lato pb-1 px-1">Total Due</h1>
//         <div class="">
//           <p class="text-sm px-[4px] py-[2px]">{dueAmount}</p>
//         </div>
//       </div>

//       <div className="flex items-center justify-center py-3 gap-3">
//         {console.log(customerDueInvoiceList)}
//         {console.log(vendorDueInvoiceList)}
//         {console.log(exporterDueInvoiceList)}
//         {console.log(carrierDueInvoiceList)}
//         {console.log(wholesellerDueInvoiceList)}
//       <ItemSelectBox
//               name="payment_id"
//               options ={ customerDueInvoiceList?.length > 0
//                           ? customerDueInvoiceList
//                           : vendorDueInvoiceList?.length > 0
//                           ? vendorDueInvoiceList
//                           : exporterDueInvoiceList?.length > 0
//                           ? exporterDueInvoiceList
//                           : wholesellerDueInvoiceList.length > 0
//                           ? wholesellerDueInvoiceList
//                           : carrierDueInvoiceList  || ''}
//               value={""}
//               onChange={handleChangeInvoice.bind(this)}
//               label={"Invoice ID"}
//               placeholder={'Select Invoice ID'}
//               style={{ maxHeight: "300px", overflowY: "scroll" }}
//               setFormErrors={formError}
//               error={"Please!! Select Invoice ID."}
//         />

//       </div>

//       <div className="relative border-[#C1CFEF] py-2.5 border w-full flex-1 rounded-xl z-50" onClick={handleDivClick2}>
//                 <DatePicker
//                   selected={transactionDate}
//                   ref={datePickerRef2}
//                   onChange={(date) => { setTransactionDate(date); setDuePaymentCustomDate(date); }}
//                   dateFormat="dd/MM/yyyy"
//                   className="w-full px-2 focus:outline-none z-20"
//                 />
//                 <span className="bg-white absolute left-2 font-semibold px-1 text-xs top-0 text-[#102048] translate-y-[-50%]">
//                   Transaction Date
//                 </span>
//       </div>

//       {paymentData.map((item, index) => (
//         <div key={index} className="">
//           <div className="flex flex-row justify-between items-center py-3 px-1">
//             <h1 className="text-md font-semibold font-lato pb-1 px-1">
//               {item.type_name}
//             </h1>
//             {index != 0 && (
//               <div
//                 className="bg-red-600 text-white rounded-md cursor-pointer"
//                 onClick={() => handleCancelMethod(item.id, index)}
//               >
//                 <p className="text-sm px-[4px] py-[2px]">Cancel</p>
//               </div>
//             )}
//           </div>

//           <div
//             className="flex items-center justify-center py-3 gap-3"
//             onClick={() => setMethodIndex(index)}
//           >
//             <ItemSelectBox
//               name="payment_id"
//               options={paymentList}
//               value={formData.payment_id}
//               onChange={handleChangeSelect.bind(this, "payment_id")}
//               label={"Method Name"}
//               placeholder={item.type_name}
//               style={{ maxHeight: "300px", overflowY: "scroll" }}
//             />
//           </div>

//           {item.type_name.toLowerCase() != "cash" && (
//             <>
//               <div
//                 className="flex items-center justify-center py-3 gap-3"
//                 onClick={() => setMethodIndex(index)}
//               >
//                 <ItemSelectBox
//                   name="account_id"
//                   options={filteredAccountList}
//                   value={formData.account_id}
//                   label={"Account Name"}
//                   onChange={handleChangeSelect.bind(this, "account_id")}
//                   placeholder="Select Account"
//                 />
//               </div>

//               <div className="flex items-center justify-center py-3 gap-3">
//                 <div className="w-full relative">
//                   <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] bg-white px-1 font-semibold">
//                     Account Number
//                   </label>
//                   <input
//                     type="text"
//                     name="name"
//                     disabled
//                     value={paymentAccountAmount[index].account_number}
//                     className="input input-bordered border-2 border-gray-500 w-full mb-[10px] rounded-xl bg-white"
//                   />
//                 </div>
//               </div>
//             </>
//           )}

//           <div className="flex items-center justify-center py-2 gap-3">
//             <div className="w-full relative">
//               <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[14px] left-[12px] bg-white px-1 font-semibold">
//                 Amount
//               </label>
//               <input
//                 type="text"
//                 name="name"
//                 placeholder="000.0"
//                 disabled={
//                   item.type_name.toLowerCase() == "cash"
//                     ? false
//                     : paymentAccountAmount[index].account_number
//                     ? false
//                     : true
//                 }
//                 //value={paymentAccountAmount[index].Amount}
//                 onChange={(e) => {
//                   setPaymentAccountAmount((prevAmount) => [
//                     ...prevAmount.slice(0, index),
//                     { ...prevAmount[index], Amount: e.target.value },
//                     ...prevAmount.slice(index + 1),
//                   ]);
//                 }}
//                 className="input input-bordered w-full mb-[10px] rounded-xl bg-white"
//               />
//             </div>
//           </div>

//           {paymentData.length > 1 && <hr />}
//         </div>
//       ))}
//       <div className="flex flex-row justify-between items-center py-3 px-1">
//         <div>
//           <h1 className="text-md font-semibold font-lato">
//             Pay with more Method
//           </h1>
//         </div>
//         <div>
//           <div
//             onClick={handleAddMethod}
//             className="flex justify-center items-center border-2 text-[#000] text-[18px] font-nunito font-bold py-[10px] px-[10px] cursor-pointer rounded-lg capitalize"
//           >
//             <i class="fa-solid fa-plus"></i>
//           </div>
//         </div>
//       </div>
//       <div>
//         <button
//           htmlFor="my_modal_due_payment"
//           onClick={(e) => {
//             if (invoiceSelect) {
//               handleSubmit(e);
//             }else{
//               setFormError(true);
//             }
//           }}
//           className="cursor-pointer w-full bg-[#3559b3] hover:bg-[#034AFF] py-[17px] text-center rounded-2xl text-[#fff] font-lato font-semibold text-lg"
//         >
//           Save
//         </button>
//       </div>
//     </div>
//   );
// };

// export default DuePaymentForm;





import Item from 'antd/es/list/Item';
import React, { useEffect, useMemo, useState, useContext, useRef } from 'react';
import { AiOutlineSearch } from 'react-icons/ai';
import { useCallback } from 'react';
import axios from 'axios';
import { useNavigate } from 'react-router-dom';
import ItemSelectBox from './ItemSelectBox';
import { AppContext } from '../context/context';
import DatePicker from "react-datepicker";
import Swal from 'sweetalert2';

const DuePaymentForm = (props) => {
  const {
    dueAmount,
    loadingCallback,
    setSeller,
    setWarningMessage,
    setShowModal,
    isOpen,
    formId,
    paymentList,
    paymentAccountList,
    filteredAccountList,
    setFilteredAccountList,
    setSelectedAccountList,
    setPaidAmount,
    paymentData,
    formData,
    setFormData,
    selectType,
    setData,
    filteredSeller,
    setFilteredSeller,
    customerDueInvoiceList,
    vendorDueInvoiceList,
    exporterDueInvoiceList,
    carrierDueInvoiceList,
    wholesellerDueInvoiceList
  } = props;

  const [uniqueMap, setUniqueMap] = useState([]);
  const [invoiceSelect, setInvoiceSelect] = useState(false);
  const [transactionDate, setTransactionDate] = useState(new Date);
  const [paymentAccountAmount, setPaymentAccountAmount] = useState([{
    methodName: '',
    AccountName: "",
    account_number: "",
    payment_type_id: '',
    payment_type_category_id: '',
    Amount: '',
  }]);
  const [dueLabel, setDueLabel] = useState('Select Invoice ID');
  const [formError, setFormError] = useState(false);
  const { setSaleInvoiceIdForDue, setPurchaseInvoiceIdForDue, setExporterInvoiceIdForDue, setCarrierInvoiceIdForDue, setWholesellerInvoiceIdForDue, setDuePaymentCustomDate } = useContext(AppContext);

  const handleSubmit = (e) => {
    e.preventDefault();

    const uniqueNamesMap = new Set();
    console.log('paymentAccountAmount...... in submit 1', paymentAccountAmount)
    const uniqueMap = paymentAccountAmount.reduce((acc, t) => {
      const key = `${t.payment_type_category_id}_${t.payment_type_id}`;

      if (!uniqueNamesMap.has(key) && Number(t.Amount) >= 0) {
        uniqueNamesMap.add(key);

        const total = paymentAccountAmount.reduce((innerAcc, item) => {
          if (
            t.payment_type_category_id === item.payment_type_category_id &&
            t.payment_type_id === item.payment_type_id && Number(item.Amount) > 0
          ) {
            return innerAcc + (Number(item.Amount));
          } else {
            return innerAcc;
          }
        }, 0);

        console.log("total Amount:", total);
        acc.push({ ...t, Amount: total });
      }

      return acc;
    }, []);

    console.log("payment data", uniqueMap);

    const totalAmount = uniqueMap.reduce((acc, item) => {
      return acc + Number(item.Amount);
    }, 0);
    console.log(totalAmount);
    console.log('paymentAccountAmount...... in submit 2', paymentAccountAmount)
    setPaidAmount(totalAmount);

    setSelectedAccountList(uniqueMap);
  };

  const navigate = useNavigate();
  const [AccountList, setAccountList] = useState([]);

  const amountData = {
    methodName: "cash",
    AccountName: "",
    account_number: "",
    payment_type_id: "",
    payment_type_category_id: "",
    Amount: '',
  }

  // const [filteredAccountList, setFilteredAccountList] = useState([])
  const [filteredAccountDetails, setFilteredAccountDetails] = useState({})
  const [methodIndex, setMethodIndex] = useState(null)
  const handleChangeInvoice = (option) => {
    const {value, label, original} = option;
    console.log("Inside SALE_invoice_id")
    console.log("original.. ",original)
    console.log("value.. ",value)
    console.log("label.. ",label)
    if(original?.sale_invoice_id != ""){
      setSaleInvoiceIdForDue(value);
      setDueLabel(label);
    }

    if(original?.purchase_invoice_id != ""){
      setPurchaseInvoiceIdForDue(value);
      setDueLabel(label);
    }
    if(original?.exporter_invoice_id != ""){
      setExporterInvoiceIdForDue(value);
      setDueLabel(label);
    }
    if(original?.carrier_invoice_id != ""){
      setCarrierInvoiceIdForDue(value);
      setDueLabel(label);
    }

    if(original?.wholesale_invoice_id != ""){
      setWholesellerInvoiceIdForDue(value);
      setDueLabel(label);
    }

    setFormError(false);
    setInvoiceSelect(true);

  }
  // const handleChangeSelect = (name, option) => {
  //   const { value, label } = option;
  //     // setFormData({
  //     //   ...formData,
  //     //   [name]: value,
  //     // });
  //     console.log("Option", name, option);
  //     console.log("PaymentList", paymentAccountList, paymentList);
  //     if (name === 'payment_id') {
  //       if (label != 'Select Payment' && value) {
  //         setFormData((prevFormData) => ({
  //           ...prevFormData,
  //           method_id: '',
  //           account_number: "",
  //         }));
  //         const selectedMethodObject = paymentList.find(
  //           (method) => method.id === value
  //         );
  //         if (selectedMethodObject) {
  //           setFilteredAccountList(selectedMethodObject.payment_type_category || []);
  //         } else {
  //           setFilteredAccountList([]);
  //         }
  //         const newArray = [...paymentData];
  //         newArray[methodIndex] = selectedMethodObject;
  //         setData(newArray);

  //         const newArray2 = [...paymentAccountAmount];
  //         newArray2[methodIndex] = {...amountData,
  //           payment_type_id: value,
  //           methodName: label,

  //         }
  //         setPaymentAccountAmount(newArray2);
  //       }
  //       if (label == 'Select Payment') {
  //         setFormData((prevFormData) => ({
  //           ...prevFormData,
  //           account_id: '',
  //           account_number: "",
  //         }));
  //       }
  //     }
  //     else if(name=='account_id'){
  //       if (label == 'Select Account') {
  //         setFormData((prevFormData) => ({
  //           ...prevFormData,
  //           account_id: '',
  //           account_number: "",
  //         }));
  //         const newArray = [...paymentAccountAmount];
  //         newArray[methodIndex] = {...amountData,
  //           account_number: "",
  //           AccountName: "",
  //           payment_type_category_id: ''
  //         }
  //         setPaymentAccountAmount(newArray);
  //         setFilteredAccountDetails({})
  //       }
  //       else{
  //         const selectedAccount = paymentAccountList.find(
  //           (method) => method.id === value
  //         );

  //         console.log("account",selectedAccount, methodIndex);
  //         if(selectedAccount){
  //           const newArray = [...paymentAccountAmount];
  //           newArray[methodIndex] = {...newArray[methodIndex],
  //             AccountName: label,
  //             account_number: selectedAccount?.account_number,
  //             payment_type_category_id: value
  //           }
  //           setPaymentAccountAmount(newArray);
  //           setFilteredAccountDetails(selectedAccount)
  //         }
  //       }
  //     }
  //  }

  //  useEffect(()=>{
  //   const selectedAccount = paymentList.find(
  //     (method) => method.type_name === "cash"
  //   );
  //   setFormData({...formData, payment_id: selectedAccount.id})
  //  },[])

  useEffect(() => {
    console.log("PaymentAccountAmount......... ",paymentAccountAmount)
  },[paymentAccountAmount])
  useEffect(() => {
    const selectedAccount = paymentList.find(
      (method) => method.type_name.toLowerCase() == "cash"
    );
    console.log("selectedAccount...............inside useeffect ", selectedAccount)
    if (selectedAccount) {
      setPaymentAccountAmount((prevAmount) => {
        if (!prevAmount.length) return [];

        return [
          {
            ...prevAmount[0],
            payment_type_id: selectedAccount.id,
            payment_type_category_id:
              selectedAccount.payment_type_category[0]?.id || "",
            methodName: selectedAccount.type_name,
          },
          ...prevAmount.slice(1), // ✅ keep the rest
        ];
      });
    }
  }, []);

  const handleChangeSelect = (name, option) => {
  const { value, label } = option;

  console.log("Option", name, option);
  console.log("PaymentList", paymentAccountList, paymentList);

  if (name === 'payment_id') {
    if (label !== 'Select Payment' && value) {
      setFormData((prevFormData) => ({
        ...prevFormData,
        method_id: '',
        account_number: '',
      }));

      const selectedMethodObject = paymentList.find(
        (method) => method.id === value
      );

      if (selectedMethodObject) {
        setFilteredAccountList(selectedMethodObject.payment_type_category || []);
      } else {
        setFilteredAccountList([]);
      }

      const newArray = [...paymentData];
      newArray[methodIndex] = selectedMethodObject;
      setData(newArray);
      console.log("paymentAccountAmount inside change select ",paymentAccountAmount)
      console.log("newArray[methodIndex]............inside change select ",newArray[methodIndex])
      const newArray2 = [...paymentAccountAmount];
      newArray2[methodIndex] = {
        ...newArray2[methodIndex], // ✅ Preserve existing data
        payment_type_category_id: newArray[methodIndex].payment_type_category[0].id,
        account_number: newArray[methodIndex].payment_type_category[0].account_number,
        payment_type_id: value,
        methodName: label,
      };
      setPaymentAccountAmount(newArray2);
    }

    if (label === 'Select Payment') {
      setFormData((prevFormData) => ({
        ...prevFormData,
        account_id: '',
        account_number: '',
      }));
    }
  }

  else if (name === 'account_id') {
    if (label === 'Select Account') {
      setFormData((prevFormData) => ({
        ...prevFormData,
        account_id: '',
        account_number: '',
      }));

      const newArray = [...paymentAccountAmount];
      newArray[methodIndex] = {
        ...newArray[methodIndex], // ✅ Preserve previously saved values
        account_number: '',
        AccountName: '',
        payment_type_category_id: ''
      };
      setPaymentAccountAmount(newArray);
      setFilteredAccountDetails({});
    }

    else {
      const selectedAccount = paymentAccountList.find(
        (method) => method.id === value
      );

      console.log("account", selectedAccount, methodIndex);
      if (selectedAccount) {
        const newArray = [...paymentAccountAmount];
        newArray[methodIndex] = {
          ...newArray[methodIndex], // ✅ Keep other values intact
          AccountName: label,
          account_number: selectedAccount?.account_number,
          payment_type_category_id: value
        };
        setPaymentAccountAmount(newArray);
        setFilteredAccountDetails(selectedAccount);
      }
    }
  }
};


  const handleAddMethod = async () => {
    if(paymentData.length < paymentList.length) {
      const selectedAccount = paymentList.find(
        (method) => method.type_name.toLowerCase() === "cash"
      );
      setData([...paymentData, selectedAccount]);
      const newArray = [...paymentAccountAmount];
      let data = {
        ...amountData,
        methodName: selectedAccount.type_name,
        payment_type_id: selectedAccount.id,
        payment_type_category_id: selectedAccount.payment_type_category[0]?.id || ""
      };
      setPaymentAccountAmount([...paymentAccountAmount, data]);
    }
  };

  const handleCancelMethod = (id, par) => {
    if(paymentData.length>1){
      const indexToRemove = paymentData.findIndex((item, index) => index === par);
      if (indexToRemove !== -1) {
        const newData = [...paymentData];
        newData.splice(indexToRemove, 1);
        setData(newData);
      }
      const indexToRemove2 = paymentAccountAmount.findIndex((item, index) => index === par);
      if (indexToRemove2 !== -1) {
        const newData2 = [...paymentAccountAmount];
        newData2.splice(indexToRemove2, 1);
        setPaymentAccountAmount(newData2);
      }
    }
  };

  const datePickerRef2 = useRef(null);

  const handleDivClick2 = () => {
    if (datePickerRef2.current) {
      datePickerRef2.current.setOpen(true); // Programmatically open the date picker
    }
  };

  return (
    <div className="duration-500">
      <div class="flex flex-row justify-between items-center py-3 px-1">
        <h1 class="text-md font-semibold font-lato pb-1 px-1">Total Due</h1>
        <div class="">
          <p class="text-sm px-[4px] py-[2px]">{dueAmount}</p>
        </div>
      </div>

      <div className="flex items-center justify-center py-3 gap-3">
        {console.log("customerDueInvoiceList.. ",customerDueInvoiceList)}
        {console.log("vendorDueInvoiceList.. ",vendorDueInvoiceList)}
        {console.log("exporterDueInvoiceList.. ",exporterDueInvoiceList)}
        {console.log("carrierDueInvoiceList.. ",carrierDueInvoiceList)}
        {console.log("wholesellerDueInvoiceList.. ",wholesellerDueInvoiceList)}
      <ItemSelectBox
              name="payment_id"
              options ={ customerDueInvoiceList?.length > 0
                          ? customerDueInvoiceList
                          : vendorDueInvoiceList?.length > 0
                          ? vendorDueInvoiceList
                          : exporterDueInvoiceList?.length > 0
                          ? exporterDueInvoiceList
                          : wholesellerDueInvoiceList.length > 0
                          ? wholesellerDueInvoiceList
                          : carrierDueInvoiceList  || ''}
              value={""}
              onChange={handleChangeInvoice.bind(this)}
              label={"Invoice ID"}
              placeholder={dueLabel}
              style={{ maxHeight: "300px", overflowY: "scroll" }}
              setFormErrors={formError}
              error={"Please!! Select Invoice ID."}
        />

      </div>

      <div className="relative border-[#C1CFEF] py-2.5 border w-full flex-1 rounded-xl z-50" onClick={handleDivClick2}>
                <DatePicker
                  selected={transactionDate}
                  ref={datePickerRef2}
                  onChange={(date) => { setTransactionDate(date); setDuePaymentCustomDate(date); }}
                  dateFormat="dd/MM/yyyy"
                  className="w-full px-2 focus:outline-none z-20"
                />
                <span className="bg-white absolute left-2 font-semibold px-1 text-xs top-0 text-[#102048] translate-y-[-50%]">
                  Transaction Date
                </span>
      </div>

      {paymentList && paymentAccountAmount[0]?.methodName && paymentData?.map((item, index) => (
        <div key={index} className="">
          <div className="flex flex-row justify-between items-center py-3 px-1">
            <h1 className="text-md font-semibold font-lato pb-1 px-1">
              {paymentAccountAmount[index]?.methodName}
            </h1>
            {index != 0 && (
              <div
                className="bg-red-600 text-white rounded-md cursor-pointer"
                onClick={() => handleCancelMethod(item.id, index)}
              >
                <p className="text-sm px-[4px] py-[2px]">Cancel</p>
              </div>
            )}
          </div>

          <div
            className="flex items-center justify-center py-3 gap-3"
            onClick={() => setMethodIndex(index)}
          >
            <ItemSelectBox
              name="payment_id"
              options={paymentList}
              value={paymentAccountAmount[index]?.payment_type_id}
              onChange={handleChangeSelect.bind(this, "payment_id")}
              label={"Method Name"}
              placeholder={item.type_name}
              style={{ maxHeight: "300px", overflowY: "scroll" }}
            />
          </div>

          {item.type_name.toLowerCase() != "cash" && (
            <>
              <div
                className="flex items-center justify-center py-3 gap-3"
                onClick={() => setMethodIndex(index)}
              >
                <ItemSelectBox
                  name="account_id"
                  options={filteredAccountList}
                  value={paymentAccountAmount[index]?.payment_type_category_id}
                  label={"Account Name"}
                  onChange={handleChangeSelect.bind(this, "account_id")}
                  placeholder="Select Account"
                />
              </div>
              {console.log("paymentData...Inside Pay due", paymentData)}
              {console.log("paymentAccountAmount...Inside Pay due", paymentAccountAmount)}
              {console.log("paymentAccountAmount...Inside Pay due", paymentAccountAmount[index]?.account_number)}
              <div className="flex items-center justify-center py-3 gap-3">
                <div className="w-full relative">
                  <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[8px] left-[12px] bg-white px-1 font-semibold">
                    Account Number
                  </label>
                  <input
                    type="text"
                    name="name"
                    disabled
                    value={paymentAccountAmount[index]?.account_number}
                    className="input input-bordered border-2 border-gray-500 w-full mb-[10px] rounded-xl bg-white"
                  />
                </div>
              </div>
            </>
          )}

          <div className="flex items-center justify-center py-2 gap-3">
            <div className="w-full relative">
              <label className="absolute z-10 font-nunito text-xs text-[#102048] -top-[14px] left-[12px] bg-white px-1 font-semibold">
                Amount
              </label>
              <input
                type="text"
                name="name"
                placeholder="000.0"
                value={paymentAccountAmount[index]?.Amount || ''}
                disabled={
                  item.type_name.toLowerCase() == "cash"
                    ? false
                    : paymentAccountAmount[index]?.account_number
                    ? false
                    : true
                }
                onChange={(e) => {
                  if (!paymentAccountAmount[index]?.payment_type_id) return;
                  setPaymentAccountAmount((prevAmount) => [
                    ...prevAmount.slice(0, index),
                    { ...prevAmount[index], Amount: e.target.value },
                    ...prevAmount.slice(index + 1),
                  ]);
                }}
                className="input input-bordered w-full mb-[10px] rounded-xl bg-white"
              />
            </div>
          </div>

          {paymentData.length > 1 && <hr />}
        </div>
      ))}
      <div className="flex flex-row justify-between items-center py-3 px-1">
        <div>
          <h1 className="text-md font-semibold font-lato">
            Pay with more Method
          </h1>
        </div>
        <div>
          <div
            onClick={handleAddMethod}
            className="flex justify-center items-center border-2 text-[#000] text-[18px] font-nunito font-bold py-[10px] px-[10px] cursor-pointer rounded-lg capitalize"
          >
            <i class="fa-solid fa-plus"></i>
          </div>
        </div>
      </div>
      <div>
        <button
          htmlFor="my_modal_due_payment"
          onClick={(e) => {
            if (invoiceSelect || 1) {
              handleSubmit(e);
            }else{
              setFormError(true);
            }
          }}
          className="cursor-pointer w-full bg-[#3559b3] hover:bg-[#034AFF] py-[17px] text-center rounded-2xl text-[#fff] font-lato font-semibold text-lg"
        >
          Save
        </button>
      </div>
    </div>
  );
};

export default DuePaymentForm;